<template>
  <div id="bene-edit-select-country-container">
    <f7-list form class="form-group">
      <f7-list-input
          :label       ="$t('beneficiary-country')"
          :placeholder ="$t('beneficiary-country')"
          :value       ="homeCountryName"

          disabled
          outline
          floating-label
      ></f7-list-input>

      <f7-list-input
          :label       ="$t('beneficiary-transfer-type')"
          :placeholder ="$t('beneficiary-transfer-type')"
          :value       ="dmExternalName"

          disabled
          outline
          floating-label
      ></f7-list-input>
    </f7-list>
  </div>
</template>

<script>
  import { mapGetters, mapActions } from "vuex";
  export default {
    props: {
      
    },
    mounted (){
      
    },
    data: function () {
      return {
      }
    },
    computed: {
      ...mapGetters('beneficiary', [
          'homeCountryList',
          'homeCountryId',
          'homeCountryName',
          'transactionTypeList',
          'transactionTypeId',
          'transactionTypeName',
          'dmExternalName',
      ])
    },
    methods: {
      ...mapActions('beneficiary', [

      ]),
      
    }
  }
</script>